import { fetcher } from '@/plugins/request';

export function addGoods(params) {
  return fetcher({
    url: '/goods/add',
    method: 'post',
    data: params,
  });
}

export function editGoods(params) {
  return fetcher({
    url: '/goods/edit',
    method: 'post',
    data: params,
  });
}

export function getItemGoods(params) {
  return fetcher({
    url: '/goods/get',
    method: 'post',
    data: params,
  });
}

export function getListGoods(params) {
  return fetcher({
    url: '/goods/get',
    method: 'post',
    data: params,
  });
}

export function upLoadImg(params) {
  return fetcher({
    url: '/file/upload',
    method: 'post',
    data: params,
  });
}

export function uploadBatchImg(params) {
  return fetcher({
    url: '/file/batch_upload',
    method: 'post',
    data: params,
  });
}

/**
 * @desc 获取商品列表
 */
export function getGoodsList(params) {
  return fetcher({
    url: '/goods/list',
    method: 'post',
    data: params,
  });
}

/**
 * @desc 更新商品信息
 */
export function goodsEdit(params) {
  return fetcher({
    url: '/goods/edit',
    method: 'post',
    data: params,
  });
}

/**
 * @desc 删除商品
 */
export function goodsDel(params) {
  return fetcher({
    url: '/goods/del',
    method: 'post',
    data: params,
  });
}

/**
 * @desc 获取库存变更记录
 */
export function sotckRecordList(params) {
  return fetcher({
    url: '/sotck_record/list',
    method: 'post',
    data: params,
  });
}
